jQuery(function($)
{
    var
        $productImageZoom = $('.js-product-image-zoom'),
        $currentViewCarousel = $('.js-product-images__slider'),
        $productImageLinks = $('.js-product-image__link'),
        $productImageZoomImage = $('.js-product-image-zoom__image'),
        $productImageZoomThumbnailLinks = $('.js-product-image-zoom__thumbnail-link'),
        productImageZoomThumbnailItemSelector = '.js-product-image-zoom__thumbnail-item',
        $videoTrigger = $('.js-product-image-zoom__video-trigger'),
        $videoView = $('.js-product-image-zoom__video'),
        $360Trigger = $('.js-product-image-zoom__360-trigger'),
        $360View = $('.js-product-image-zoom__360');

    /**
	 * Initialize modal events
	 */
    function initModalEvents()
    {
        var $productImageZoom = $('.js-product-image-zoom');

        $productImageZoom.on(orion.constants.EventModalClosed, handleModalClosed);
    }

    /**
	 * Sync product zoom image with product image slider
	 */
    function syncZoomAndSlider()
    {
        if ($currentViewCarousel.length > 0)
        {
            var currentImageElement = $currentViewCarousel.find('.tns-slide-active img');

            if (!currentImageElement.length) return;

            var currentImage = currentImageElement.attr('src');
            var currentZoomImageSrc = currentImage.replace('product-main-image', 'product-zoom-image');

            $productImageZoomImage.attr('src', currentZoomImageSrc);
        }
    }

    /**
	 * Open image zoom view after click on product image
	 */
    function handleImageClick(event)
    {
        event.preventDefault();

        $productImageZoom.modal();
    }

    /**
	 * Show the zoom image of the clicked thumbnail
	 */
    function handleThumbnailClick(event)
    {
        event.preventDefault();

        console.log('handleThumbnailClick');

        if ($productImageZoomImage.hasClass('hidden'))
        {
            $productImageZoomImage.removeClass('hidden');
        }

        $videoView.each(function()
        {
            if (!$(this).hasClass('hidden'))
            {
                $(this).addClass('hidden');
            }
        });

        if (!$360View.hasClass('hidden'))
        {
            $360View.addClass('hidden');
        }

        if ($videoView.length)
        {
            $videoView.each(function()
            {
                $(this).closest('video')
                    .get(0)
                    .pause();
                $(this).closest('video')
                    .get(0).currentTime = 0;
            });
        }

        $(productImageZoomThumbnailItemSelector).removeClass('product-image-zoom__thumbnail-item--active');

        var $clickedThumbnail = $(this);
        var clickedThumbnailSrc = $clickedThumbnail.find('img').attr('src');

        var zoomImageSrc = clickedThumbnailSrc.replace('product-list-image-thumbnail', 'product-zoom-image');

        $productImageZoomImage.attr('src', zoomImageSrc);

        $clickedThumbnail.parent(productImageZoomThumbnailItemSelector)
            .addClass('product-image-zoom__thumbnail-item--active');
    }

    /**
	 * Close modal
	 */
    function handleModalClosed()
    {
        if ($videoView.length)
        {
            $videoView.each(function()
            {
                $(this).closest('video')
                    .get(0)
                    .pause();
                $(this).closest('video')
                    .get(0).currentTime = 0;
            });
        }
    }

    /**
	 * Sync image views after slide
	 */
    document.addEventListener(orion.constants.EventProductImageIndexChanged, syncZoomAndSlider);

    /**
	 * Handle click on product images
	 */
    $productImageLinks.each(function()
    {
        $(this).on('click', handleImageClick);
    });

    /**
	 * Handle click on image thumbnails in zoom view
	 */
    $productImageZoomThumbnailLinks.each(function()
    {
        $(this).on('click', handleThumbnailClick);
    });

    /**
	 * Show 360 view after click on the 360 trigger
	 */
    $360Trigger.on('click', function(event)
    {
        event.preventDefault();

        if ($productImageZoom.hasClass('hidden') || $productImageZoom.parent().hasClass('hidden'))
        {
            $productImageZoom.modal();
        }

        if ($360View.hasClass('hidden'))
        {
            $360View.removeClass('hidden');
        }

        if (!$videoView.hasClass('hidden'))
        {
            $videoView.addClass('hidden');
        }

        if (!$productImageZoomImage.hasClass('hidden'))
        {
            $productImageZoomImage.addClass('hidden');
        }

        if ($videoView.length)
        {
            $videoView.each(function()
            {
                $(this).closest('video')
                    .get(0)
                    .pause();
                $(this).closest('video')
                    .get(0).currentTime = 0;
            });
        }

        $360View.css({ height: '100%', width: '100%' }).trigger(orion.constants.EventProductImageLoad360Image);

        $(productImageZoomThumbnailItemSelector).removeClass('product-image-zoom__thumbnail-item--active');

        var $clickedThumbnail = $(this);

        $clickedThumbnail.parent().addClass('product-image-zoom__thumbnail-item--active');
    });

    /**
	 * Show video after click on the video trigger
	 */
    $videoTrigger.on('click', function(event)
    {
        event.preventDefault();

        var target = $(this).data('video-id');

        if ($productImageZoom.hasClass('hidden') || $productImageZoom.parent().hasClass('hidden'))
        {
            $productImageZoom.modal();
        }

        $videoView = $('.js-product-image-zoom__video');

        var $targetVideoView = $videoView.filter(function()
        {
            return $(this).data('video-id') == target;
        });

        $videoView.each(function()
        {
            $(this).addClass('hidden');

            $(this).closest('video')
                .get(0)
                .pause();
            $(this).closest('video')
                .get(0).currentTime = 0;
        });

        if ($targetVideoView.hasClass('hidden'))
        {
            $targetVideoView.removeClass('hidden');
        }

        if (!$productImageZoomImage.hasClass('hidden'))
        {
            $productImageZoomImage.addClass('hidden');
        }

        if (!$360View.hasClass('hidden'))
        {
            $360View.addClass('hidden');
        }

        $targetVideoView.closest('video').get(0)
            .play();

        $(productImageZoomThumbnailItemSelector).removeClass('product-image-zoom__thumbnail-item--active');

        var $clickedThumbnail = $(this);

        $clickedThumbnail.parent().addClass('product-image-zoom__thumbnail-item--active');
    });

    /**
	 * Init modal events after the modal is appended to the body
	 */
    $('body').on(orion.constants.EventModalAppended, initModalEvents);

    syncZoomAndSlider();
});
